
export default {
  retests: (state) => (assessmentId) => state.retests && state.retests[assessmentId] ? state.retests[assessmentId] : [],
  allRetests: (state) => state.retests,
  retestReasons: (state) => state.retestReasons
}
